import "./Level1.scss";

export default function Level1() {
  return (
    <div className="level1__container">
      <div className="level1__puzzle">
        <div className="level1__file">
          <p className="level1__letter">A</p>
          <p className="level1__clue">0</p>
        </div>
        <div className="level1__file">
          <p className="level1__letter">B</p>
          <p className="level1__clue">2</p>
        </div>
        <div className="level1__file">
          <p className="level1__letter">C</p>
          <p className="level1__clue">4</p>
        </div>
        <div className="level1__file">
          <p className="level1__letter">D</p>
          <p className="level1__clue">6</p>
        </div>
        <div className="level1__file">
          <p className="level1__letter">E</p>
          <p className="level1__clue">8</p>
        </div>
        <div className="level1__file">
          <p className="level1__letter">F</p>
          <p className="level1__clue">10</p>
        </div>
        <div className="level1__file">
          <p className="level1__letter">G</p>
          <p className="level1__clue">12</p>
        </div>
        <div className="level1__file">
          <p className="level1__letter">H</p>
          <p className="level1__clue">14</p>
        </div>
        <div className="level1__file">
          <p className="level1__letter">I</p>
          <p className="level1__clue">16</p>
        </div>
        <div className="level1__file">
          <p className="level1__letter">J</p>
          <p className="level1__clue">18</p>
        </div>
        <div className="level1__file">
          <p className="level1__letter">K</p>
          <p className="level1__clue">20</p>
        </div>
        <div className="level1__file">
          <p className="level1__letter">L</p>
          <p className="level1__clue">22</p>
        </div>
        <div className="level1__file">
          <p className="level1__letter">M</p>
          <p className="level1__clue">24</p>
        </div>
        <div className="level1__file">
          <p className="level1__letter">N</p>
          <p className="level1__clue">26</p>
        </div>
        <div className="level1__file">
          <p className="level1__letter">O</p>
          <p className="level1__clue">28</p>
        </div>
        <div className="level1__file">
          <p className="level1__letter">P</p>
          <p className="level1__clue">30</p>
        </div>
        <div className="level1__file">
          <p className="level1__letter">Q</p>
          <p className="level1__clue">32</p>
        </div>
        <div className="level1__file">
          <p className="level1__letter">R</p>
          <p className="level1__clue">34</p>
        </div>
        <div className="level1__file">
          <p className="level1__letter">S</p>
          <p className="level1__clue">36</p>
        </div>
        <div className="level1__file">
          <p className="level1__letter">T</p>
          <p className="level1__clue">38</p>
        </div>
        <div className="level1__file">
          <p className="level1__letter">U</p>
          <p className="level1__clue">40</p>
        </div>
        <div className="level1__file">
          <p className="level1__letter">V</p>
          <p className="level1__clue">42</p>
        </div>
        <div className="level1__file">
          <p className="level1__letter">W</p>
          <p className="level1__clue">44</p>
        </div>
        <div className="level1__file">
          <p className="level1__letter">X</p>
          <p className="level1__clue">46</p>
        </div>
        <div className="level1__file">
          <p className="level1__letter">Y</p>
          <p className="level1__clue">48</p>
        </div>
        <div className="level1__file">
          <p className="level1__letter">Z</p>
          <p className="level1__clue">50</p>
        </div>
      </div>

      <div className="level1__guess-container">
        <span className="level1__guess">
          6 &nbsp; 8 &nbsp; 36 &nbsp; 4 &nbsp; 16 &nbsp; 10 &nbsp; 34 &nbsp; 0
          &nbsp; 34
        </span>
      </div>
    </div>
  );
}
